
import { Component, Vue } from "vue-property-decorator";
import { SMAdditionalInfo, SMHotjar } from "@/store";
import { EMPLOYEE_HOME_HOTJAR_SITE_ID } from "@/constants/hotjar";

SMHotjar.initHotjar(EMPLOYEE_HOME_HOTJAR_SITE_ID);

@Component({
  components: {
    PricingRequestsPopups: () => import("@/modules/Pricing/Requests/PricingRequestsPopups.vue"),
  },
})
export default class Employee extends Vue {
  get dependantsList() {
    return SMAdditionalInfo.dependantsList;
  }

  mounted() {
    SMAdditionalInfo.fetchDependantsList();
  }
}
